module.exports = __webpack_public_path__ + "static/media/alertadd.b606bd1b.svg";